import { z } from 'zod'

export type AttributesButton = {
  title: string
  href: string
  /** Icon src. Either a path to a local icon or a URL */
  icon?: string
}

export const attributesButtonSchema = z.object({
  title: z.string(),
  href: z.string(),
  icon: z.string().optional(),
}) satisfies z.ZodType<AttributesButton>
